import { useUserContext } from "../../utils/userContext";

/**
 * Check of the current user has one of the permisssion req or is a admin to render the child element
 * 
 * @param props {childern: JSX.Element, permissions: string[]} 
 * @returns undefined | children
 */
const PermissionGuard = (props: {children: JSX.Element, permissions: string[]}) => {
  const { permission, user } = useUserContext();

  if(user?.roles.indexOf("Admin") !== -1){
    return <> {props.children} </>
  }

  if(props.permissions.length === 0){
    return <> {props.children} </>
  }

  if(permission.some(x => props.permissions.includes(x))) {
    return <>{props.children}</>;
  }

  return <></>
};

export default PermissionGuard;